export default "__VITE_ASSET__BXhv4YOt__"